import * as React from 'react';
import './button.scss';
import { ReactComponent as CheckListIcon } from '../../assets/icons/check_list.svg';
import { ReactComponent as RefreshIcon } from '../../assets/icons/refresh.svg';
import { ReactComponent as RigthCircleIcon } from '../../assets/icons/arrow_right_circle.svg';
import { BsCloudArrowDown, BsDownload } from 'react-icons/bs';

interface Props {
  action?: Function;
  label: string;
  type: string;
  height?: number;
  icon?: string;
}

const Button: React.FunctionComponent<Props> = ({ action, label, type, height = 50, icon }) => {
  const buttonClick = () => {
    action && action(true);
  };

  document.documentElement.style.setProperty('--button-height', `${height}px`);

  const classRender = () => {
    // TODO: Use switch case
    if (type === 'type1') {
      return `button button__type1`;
    } else if (type === 'type2') {
      return `button button__type2`;
    } else if (type === 'type3') {
      return `button button__type3`;
    } else if (type === 'type4') {
      return `button button__type4`;
    } else if (type === 'type5') {
      return `button button__type5`;
    } else if (type === 'type6') {
      return `button button__type6`;
    } else if (type === 'type7') {
      return `button button__type7`;
    } else if (type === 'type8') {
      return `button button__type8`;
    } else if (type === 'type9') {
      return `button button__type9`;
    } else if (type === 'type10') {
      return `button button__type10`;
    } else if (type === 'type11') {
      return `button button__type11`;
    } else if (type === 'type12') {
      return `button button__type12`;
    } else if (type === 'type13') {
      return `button button__type13`;
    } else if (type === 'type14') {
      return `button button__type14`;
    } else if (type === 'type15') {
      return `button button__type15`;
    }
    return '';
  };

  const iconRender = () => {
    if (icon === 'CheckListIcon') {
      return <CheckListIcon />;
    } else if (icon === 'RefreshIcon') {
      return <RefreshIcon />;
    } else if (icon === 'RigthCircleIcon') {
      return <RigthCircleIcon />;
    } else if (icon === 'cloudIcon') {
      return <BsCloudArrowDown size={16} />;
    } else if (icon === 'downloadIcon') {
      return <BsDownload size={16} />;
    }
    return '';
  };

  return (
    <button type="button" className={classRender()} onClick={buttonClick}>
      {icon ? (
        <div className="button__icon">
          <div className="button__icon__label">{label}</div>
          {iconRender()}
        </div>
      ) : (
        <div>{label}</div>
      )}
    </button>
  );
};
export default Button;
